module.exports = __webpack_public_path__ + "assets/icona_chef.6dc984a3.svg";